import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import UpdateProfile from "./updateProfile";

const API = localStorage.getItem("assethost");

export default class IndividualProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // request state
      loading: true,
      msg: "",
      toastColor: "",
      showUpdate: false,

      // flattened profile (user-level)
      username: "",
      fullName: "",
      isPaidService: "",
      activeStatus: "",
      profileType: "",
      townName: "",

      // flattened individual profile
      firstName: "",
      surname: "",
      middleName: "",
      nationalIdNumber: "",
      cellPhone: "",
      gender: "",
      email: "",
      mobileMoneyNumber: "",
      nationality: "",
      houseNumberStreet: "",
      suburb: "",
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const userId =
      this.props.id || params.get("id") || sessionStorage.getItem("userId");
    this.loadProfile(userId);
  }

  safeText(v) {
    return v === null || v === undefined || v === "" ? "" : String(v);
  }

  loadProfile(userId) {
    const token = sessionStorage.getItem("token");
    if (!token || !userId) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    axios
      .get(API + `/users/${userId}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const p = response.data || {};
        const i = p.individualProfile || {};
        const nationalityRaw = i.nationality;
        const nationalityStr =
          nationalityRaw && typeof nationalityRaw === "object"
            ? nationalityRaw.label || nationalityRaw.value || ""
            : nationalityRaw || "";

        this.setState({
          loading: false,
          msg: "",
          toastColor: "",

          username: this.safeText(p.username),
          fullName: this.safeText(p.fullName),
          isPaidService: this.safeText(p.isPaidService),
          activeStatus: this.safeText(p.activeStatus),
          profileType: this.safeText(p.profileType),
          townName: this.safeText(p.townName),

          firstName: this.safeText(i.firstName),
          surname: this.safeText(i.surname),
          middleName: this.safeText(i.middleName),
          nationalIdNumber: this.safeText(i.nationalIdNumber),
          cellPhone: this.safeText(i.cellPhone),
          gender: this.safeText(i.gender),
          email: this.safeText(i.email),
          mobileMoneyNumber: this.safeText(i.mobileMoneyNumber),
          nationality: this.safeText(nationalityStr),
          houseNumberStreet: this.safeText(i.houseNumberStreet),
          suburb: this.safeText(i.suburb),
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load profile.",
          toastColor: "danger",
        });
      });
  }

  render() {
    const s = this.state;

    if (s.loading) {
      return <Spinner className="" />;
    }

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    return (
      <div className="min-h-screen flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title={`Profile: ${s.fullName || "Individual"}`} />
          {divMsg}
          <div className="w-full grow px-5 flex flex-col items-center justify-center">
            <div className="w-full max-w-3xl mt-8 h-full overflow-y-auto">
              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Full Name</div>
                  <div>
                    {s.fullName || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Is Paid Service?</div>
                  <div>
                    {s.isPaidService || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Is Active?</div>
                  <div>
                    {s.activeStatus || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Profile Type</div>
                  <div>
                    {s.profileType || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Town/City</div>
                  <div>
                    {s.townName || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Firstname</div>
                  <div>
                    {s.firstName || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Surname</div>
                  <div>
                    {s.surname || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Middle name</div>
                  <div>
                    {s.middleName || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                {!s.passportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">National ID</div>
                    <div>
                      {s.nationalIdNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {s.passportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Passport Number</div>
                    <div>
                      {s.passportNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Cellphone</div>
                  <div>
                    {s.cellPhone || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Gender</div>
                  <div>
                    {s.gender || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Email</div>
                  <div>
                    {s.email || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Mobile Money Number</div>
                  <div>
                    {s.mobileMoneyNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Nationality</div>
                  <div>
                    {s.nationality || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">House Number Street</div>
                  <div>
                    {s.houseNumberStreet || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Suburb</div>
                  <div>
                    {s.suburb || <span className="text-gray-400">-</span>}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-8 mt-2">
              <button
                type="button"
                name="update"
                className="btn btn-success"
                onClick={() => this.setState({ showUpdate: true })}
              >
                Update Profile
              </button>
              <button
                type="button"
                name="cancel"
                className="btn btn-success"
                onClick={() => window.history.back()}
              >
                Cancel
              </button>
            </div>
          </div>
          <Footer />
        </div>
        {s.showUpdate && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50">
            <div className="bg-white rounded-b-md w-[99%] h-5/6 overflow-y-scroll flex flex-col px-7">
              <Banner
                key={`poll-message-banner`}
                title="Topup poll message"
                withIcons={false}
              />
              <div className="flex flex-col items-center justify-center grow">
                <UpdateProfile
                  onClose={() => this.setState({ showUpdate: false })}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
